import * as types from 'store/modules/hrms18e/mutation-types'
import _ from 'lodash'
import moment from 'moment'
import hrms18e from 'api/hrms18e'
import swal from 'sweetalert'
import hrms18eLabels from 'assets/labels/hrms18e'
import { hrms18eColumns } from 'assets/columns/hrms18e'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hrms18eLabels,
    columns: hrms18eColumns(),
    index: {
      parent: {
        total: 0,
        rows: []
      },
      child: {
        total: 0,
        rows: []
      },
      childByParent: {
        total: 0,
        rows: []
      }
    },
    response: {
      status: '',
      message: ''
    },
    sumDayInMonth: 31,
    searchIndex: {},
    currentDayParent: '00',
    currentTypeworkParent: '',
    targetTypeworkParent: '',
    currentCodshiftParent: '',
    targetCodshiftParent: '',
    targetCodcalenParent: '',
    inlineDataParent: [],
    currentDayChild: '00',
    currentTypeworkChild: '',
    targetTypeworkChild: '',
    currentCodshiftChild: '',
    targetCodshiftChild: '',
    targetCodempidChild: '',
    inlineDataChild: [],
    traditionalDays: {
      total: 0,
      rows: [{}]
    },
    shutdownDays: {
      total: 0,
      rows: [{}]
    }
  },
  getters: {
    [types.GET_HRMS18E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS18E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRMS18E_SUM_DAY_IN_MONTH] (state) {
      return state.sumDayInMonth
    },
    [types.GET_HRMS18E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS18E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS18E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS18E_SEARCH_INDEX] (state) {
      return state.searchIndex
    },
    [types.GET_HRMS18E_CURRENT_TYPEWORK_PARENT] (state) {
      return state.currentTypeworkParent
    },
    [types.GET_HRMS18E_TARGET_TYPEWORK_PARENT] (state) {
      return state.targetTypeworkParent
    },
    [types.GET_HRMS18E_CURRENT_CODSHIFT_PARENT] (state) {
      return state.currentCodshiftParent
    },
    [types.GET_HRMS18E_TARGET_CODSHIFT_PARENT] (state) {
      return state.targetCodshiftParent
    },
    [types.GET_HRMS18E_TARGET_CODCALEN_PARENT] (state) {
      return state.targetCodcalenParent
    },
    [types.GET_HRMS18E_INLINE_DATA_PARENT] (state) {
      return state.inlineDataParent
    },
    [types.GET_HRMS18E_CURRENT_DAY_PARENT] (state) {
      return state.currentDayParent
    },
    [types.GET_HRMS18E_CURRENT_TYPEWORK_CHILD] (state) {
      return state.currentTypeworkChild
    },
    [types.GET_HRMS18E_TARGET_TYPEWORK_CHILD] (state) {
      return state.targetTypeworkChild
    },
    [types.GET_HRMS18E_CURRENT_CODSHIFT_CHILD] (state) {
      return state.currentCodshiftChild
    },
    [types.GET_HRMS18E_TARGET_CODSHIFT_CHILD] (state) {
      return state.targetCodshiftChild
    },
    [types.GET_HRMS18E_TARGET_CODEMPID_CHILD] (state) {
      return state.targetCodempidChild
    },
    [types.GET_HRMS18E_INLINE_DATA_CHILD] (state) {
      return state.inlineDataChild
    },
    [types.GET_HRMS18E_CURRENT_DAY_CHILD] (state) {
      return state.currentDayChild
    },
    [types.GET_HRMS18E_TRADITIONAL_DAYS] (state) {
      return state.traditionalDays
    },
    [types.GET_HRMS18E_SHUTDOWN_DAYS] (state) {
      return state.shutdownDays
    }
  },
  mutations: {
    [types.SET_HRMS18E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS18E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRMS18E_SUM_DAY_IN_MONTH] (state) {
      state.sumDayInMonth = moment(moment().format(state.searchIndex.year + '-' + _.padStart(state.searchIndex.month, 2, '0') + '-01')).daysInMonth()
    },
    [types.SET_HRMS18E_SEARCH_INDEX] (state, searchIndex) {
      state.searchIndex = searchIndex
    },
    [types.SET_HRMS18E_UPDATE_COLUMNS_PARENT] (state) {
      let sumDayInMonth = state.sumDayInMonth
      for (var keyLang of configLabel.allLang) {
        let columnKeysParent = state.columns[keyLang].indexParent.map(function (columnParent) {
          return columnParent.key
        }).filter(function (keyValue) {
          return keyValue.indexOf('codshift') > -1
        })
        for (let day = 1; day <= 31; day++) {
          if (typeof columnKeysParent[day - 1] !== 'undefined' && day > sumDayInMonth) {
            let columnIndexParent = state.columns[keyLang].indexParent.map(function (columnParent) {
              return columnParent.key
            }).indexOf(columnKeysParent[day - 1])
            state.columns[keyLang].indexParent.splice(columnIndexParent, 1)
          }
          if (typeof columnKeysParent[day - 1] === 'undefined' && day <= sumDayInMonth) {
            state.columns[keyLang].indexParent.push({
              key: 'codshift' + _.padStart(day, 2, '0'),
              name: '',
              labelCodapp: 'CODSHIFT',
              labelIndex: _.padStart(day, 2, '0'),
              class: 'align-center',
              style: 'min-width: 60px;',
              inlineType: 'text',
              eventName: 'codshift' + _.padStart(day, 2, '0'),
              columnDisabledCondition (dataRow, key, index) {
                let columnDay = parseInt(key.replace('codshift', ''))
                let month = dataRow.month
                let year = dataRow.year
                let columnDate = moment(columnDay + '/' + month + '/' + year, 'DD/MM/YYYY')
                let currentDate = moment().startOf('day')
                return columnDate < currentDate
              },
              columnClassCondition (dataRow, key, index) {
                let day = key.substring(8)
                let typwork = dataRow['typwork' + day]
                if (typwork === 'H') {
                  return 'typework-h-cell'
                } else if (typwork === 'W') {
                  return 'typework-w-cell'
                } else if (typwork === 'S') {
                  return 'typework-s-cell'
                } else if (typwork === 'T') {
                  return 'typework-t-cell'
                } else if (typwork === 'L') {
                  return 'typework-l-cell'
                }
              }
            })
          }
        }
      }
    },
    [types.SET_HRMS18E_UPDATE_COLUMNS_CHILD] (state) {
      let sumDayInMonth = state.sumDayInMonth
      for (var keyLang of configLabel.allLang) {
        let columnKeysChild = state.columns[keyLang].indexChild.map(function (columnChild) {
          return columnChild.key
        }).filter(function (keyValue) {
          return keyValue.indexOf('codshift') > -1
        })
        for (let day = 1; day <= 31; day++) {
          if (typeof columnKeysChild[day - 1] !== 'undefined' && day > sumDayInMonth) {
            let columnIndexChild = state.columns[keyLang].indexChild.map(function (columnChild) {
              return columnChild.key
            }).indexOf(columnKeysChild[day - 1])
            state.columns[keyLang].indexChild.splice(columnIndexChild, 1)
          }
          if (typeof columnKeysChild[day - 1] === 'undefined' && day <= sumDayInMonth) {
            state.columns[keyLang].indexChild.push({
              key: 'codshift' + _.padStart(day, 2, '0'),
              name: '',
              labelCodapp: 'CODSHIFT',
              labelIndex: _.padStart(day, 2, '0'),
              class: 'align-center',
              style: 'min-width: 60px;',
              inlineType: 'text',
              eventName: 'codshift' + _.padStart(day, 2, '0'),
              columnDisabledCondition (dataRow, key, index) {
                let columnDay = parseInt(key.replace('codshift', ''))
                let month = dataRow.month
                let year = dataRow.year
                let columnDate = moment(columnDay + '/' + month + '/' + year, 'DD/MM/YYYY')
                let currentDate = moment().startOf('day')
                return columnDate < currentDate
              },
              columnClassCondition (dataRow, key, index) {
                let day = key.substring(8)
                let typwork = dataRow['typwork' + day]
                if (typwork === 'H') {
                  return 'typework-h-cell'
                } else if (typwork === 'W') {
                  return 'typework-w-cell'
                } else if (typwork === 'S') {
                  return 'typework-s-cell'
                } else if (typwork === 'T') {
                  return 'typework-t-cell'
                } else if (typwork === 'L') {
                  return 'typework-l-cell'
                }
              }
            })
          }
        }
      }
    },
    [types.SET_HRMS18E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].indexParent = configLabel.replaceLabelToColumns(state.columns[keyLang].indexParent, labels[keyLang])
        state.columns[keyLang].indexChild = configLabel.replaceLabelToColumns(state.columns[keyLang].indexChild, labels[keyLang])
      }
    },
    [types.SET_HRMS18E_LABELS] (state, { labels, month, year }) {
      if (month !== '' && year !== '') {
        let sumDayInMonth = state.sumDayInMonth
        for (let day = 1; day <= 31; day++) {
          if (day <= sumDayInMonth) {
            var mydate = year + '-' + _.padStart(month, 2, '0') + '-' + _.padStart(day, 2, '0') + 'T00:00:00'
            var fullDayName = moment(mydate).format('dddd')
            labels['en']['CODSHIFT'][_.padStart(day, 2, '0')] = fullDayName.substring(0, 3).toUpperCase() + day
            labels['th']['CODSHIFT'][_.padStart(day, 2, '0')] = fullDayName.substring(0, 3).toUpperCase() + day
          } else {
            labels['en']['CODSHIFT'][_.padStart(day, 2, '0')] = ''
            labels['th']['CODSHIFT'][_.padStart(day, 2, '0')] = ''
          }
        }
      }
      state.labels = labels
    },
    [types.SET_HRMS18E_INDEX_PARENT] (state, indexParent) {
      state.index.parent = indexParent
      state.targetTypeworkParent = 'typwork01'
      state.targetCodshiftParent = 'codshift01'
      if (indexParent.rows.length > 0) {
        state.currentTypeworkParent = state.index.parent.rows[0]['typwork01']
        state.currentCodshiftParent = state.index.parent.rows[0]['codshift01']
        state.targetCodcalenParent = state.index.parent.rows[0]['codcalen']
      } else {
        state.currentTypeworkParent = ''
        state.currentCodshiftParent = ''
        state.targetCodcalenParent = ''
      }
    },
    [types.SET_HRMS18E_INLINE_DATA_PARENT] (state, inlineDataParent) {
      state.inlineDataParent = inlineDataParent
    },
    [types.SET_HRMS18E_INDEX_CHILD_BY_PARENT] (state) {
      /* let childRowsFiltered = state.index.child.rows.filter(function (childRow) {
        // new
        let codcalenKeys = Object.keys(childRow).filter(function (keyValue) {
          return keyValue.indexOf('codcalen') > -1
        })
        let validGroup = false
        for (let day = 1; day <= codcalenKeys.length; day++) {
          if (validGroup) {
            break
          }
          validGroup = childRow['codcalen' + _.padStart(day, 2, '0')] === state.targetCodcalenParent
        }
        return validGroup
        // old
        // return childRow.codcalen === state.targetCodcalenParent
      }) */
      // state.index.childByParent.total = childRowsFiltered.length
      // state.index.childByParent.rows = childRowsFiltered
      state.index.childByParent = state.index.child
    },
    [types.SET_HRMS18E_INDEX_CHILD] (state, indexChild) {
      state.index.child = indexChild
    },
    [types.SET_HRMS18E_CURRENT_TYPEWORK_PARENT] (state, currentTypeworkParent) {
      state.currentTypeworkParent = currentTypeworkParent
    },
    [types.SET_HRMS18E_TARGET_TYPEWORK_PARENT] (state, targetTypeworkParent) {
      state.targetTypeworkParent = targetTypeworkParent
    },
    [types.SET_HRMS18E_CURRENT_CODSHIFT_PARENT] (state, currentCodshiftParent) {
      state.currentCodshiftParent = currentCodshiftParent
    },
    [types.SET_HRMS18E_TARGET_CODSHIFT_PARENT] (state, targetCodshiftParent) {
      state.targetCodshiftParent = targetCodshiftParent
    },
    [types.SET_HRMS18E_TYPEWORK_TO_TARGET_TYPEWORK_PARENT] (state, { typework, targetTypework }) {
      let parentIndex = state.index.parent.rows.map(function (parentRow) {
        return parentRow.codcalen
      }).indexOf(state.targetCodcalenParent)
      if (parentIndex >= 0 &&
          state.index.parent.rows[parentIndex][targetTypework] !== typework &&
          state.index.parent.rows[parentIndex][targetTypework] !== 'L' && state.index.parent.rows[parentIndex][targetTypework]) {
        state.index.parent.rows[parentIndex][targetTypework] = typework
        state.index.parent.rows[parentIndex][targetTypework + '-flgEdit'] = 'Y'
        state.index.parent.rows[parentIndex]['flgEdit'] = true
      }
      state.currentTypeworkParent = typework
      for (let childIndex in state.index.child.rows) {
        if (state.index.child.rows[childIndex][targetTypework]) {
          if (state.index.child.rows[childIndex]['codcalen' + targetTypework.substring(7)] === state.targetCodcalenParent &&
              state.index.child.rows[childIndex][targetTypework] !== typework &&
              state.index.child.rows[childIndex][targetTypework] !== 'L') {
            state.index.child.rows[childIndex][targetTypework] = typework
            state.index.child.rows[childIndex][targetTypework + '-flgEdit'] = 'Y'
            state.index.child.rows[childIndex]['flgEdit'] = true
          }
        }
      }
    },
    [types.SET_HRMS18E_CODSHIFT_TO_TARGET_CODSHIFT_PARENT] (state, { codshift, targetCodshift }) {
      let parentIndex = state.index.parent.rows.map(function (parentRow) {
        return parentRow.codcalen
      }).indexOf(state.targetCodcalenParent)
      if (parentIndex >= 0 && state.index.parent.rows[parentIndex][targetCodshift] !== codshift) {
        state.index.parent.rows[parentIndex][targetCodshift] = codshift
        state.index.parent.rows[parentIndex][targetCodshift + '-flgEdit'] = 'Y'
        state.index.parent.rows[parentIndex]['flgEdit'] = true
      }
      state.currentCodshiftParent = codshift
      for (let childIndex in state.index.child.rows) {
        if (state.index.child.rows[childIndex]['codcalen' + targetCodshift.substring(8)] === state.targetCodcalenParent && state.index.child.rows[childIndex][targetCodshift] !== codshift) {
          state.index.child.rows[childIndex][targetCodshift] = codshift
          state.index.child.rows[childIndex][targetCodshift + '-flgEdit'] = 'Y'
          state.index.child.rows[childIndex]['flgEdit'] = true
        }
      }
    },
    [types.SET_HRMS18E_TARGET_CODCALEN_PARENT] (state, targetCodcalenParent) {
      state.targetCodcalenParent = targetCodcalenParent
    },
    [types.SET_HRMS18E_CURRENT_DAY_PARENT] (state, currentDayParent) {
      state.currentDayParent = currentDayParent
    },
    [types.SET_HRMS18E_CURRENT_TYPEWORK_CHILD] (state, currentTypeworkChild) {
      state.currentTypeworkChild = currentTypeworkChild
    },
    [types.SET_HRMS18E_TARGET_TYPEWORK_CHILD] (state, targetTypeworkChild) {
      state.targetTypeworkChild = targetTypeworkChild
    },
    [types.SET_HRMS18E_CURRENT_CODSHIFT_CHILD] (state, currentCodshiftChild) {
      state.currentCodshiftChild = currentCodshiftChild
    },
    [types.SET_HRMS18E_TARGET_CODSHIFT_CHILD] (state, targetCodshiftChild) {
      state.targetCodshiftChild = targetCodshiftChild
    },
    [types.SET_HRMS18E_TYPEWORK_TO_TARGET_TYPEWORK_CHILD] (state, { typework, targetTypework }) {
      let index = state.index.child.rows.map(function (childRow) {
        return childRow.codempid
      }).indexOf(state.targetCodempidChild)
      if (index >= 0 && state.index.child.rows[index][targetTypework]) {
        state.index.child.rows[index][targetTypework] = typework
        state.index.child.rows[index][targetTypework + '-flgEdit'] = 'Y'
        state.index.child.rows[index]['flgEdit'] = true
      }
      state.currentTypeworkChild = typework
    },
    [types.SET_HRMS18E_CODSHIFT_TO_TARGET_CODSHIFT_CHILD] (state, { codshift, targetCodshift }) {
      let childIndex = state.index.child.rows.map(function (childRow) {
        return childRow.codempid
      }).indexOf(state.targetCodempidChild)
      if (childIndex >= 0 && state.index.child.rows[childIndex][targetCodshift]) {
        state.index.child.rows[childIndex][targetCodshift] = codshift
        state.index.child.rows[childIndex][targetCodshift + '-flgEdit'] = 'Y'
        state.index.child.rows[childIndex]['flgEdit'] = true
      }
    },
    [types.SET_HRMS18E_TARGET_CODEMPID_CHILD] (state, targetCodempidChild) {
      state.targetCodempidChild = targetCodempidChild
    },
    [types.SET_HRMS18E_ADD_INLINE_CODEMPID_CHILD] (state, { codempid, descCodempid }) {
      let addChildIndex = state.index.child.rows.map(function (childRow) {
        return childRow.codempid
      }).indexOf(codempid)
      if (addChildIndex > -1) {
        state.index.child.rows[addChildIndex].codempid = codempid
        state.index.child.rows[addChildIndex].desc_codempid = descCodempid
      }
    },
    [types.SET_HRMS18E_ADDED_DATA_ROW_CHILD] (state, dataRow) {
      state.index.child.rows.push(dataRow)
      let total = state.index.child.rows.length
      state.index.child.total = total
      let index = total - 1
      state.index.child.rows[index].codcalen = state.targetCodcalenParent
      let dataKeys = Object.keys(dataRow).filter(function (keyValue) {
        return keyValue.indexOf('codshift') > -1
      })
      let parentIndex = state.index.parent.rows.map(function (dataRow) {
        return dataRow.codcalen
      }).indexOf(state.targetCodcalenParent)
      for (let day = 1; day <= dataKeys.length; day++) {
        state.index.child.rows[index]['codshift' + _.padStart(day, 2, '0')] = (typeof state.index.parent.rows[parentIndex] === 'undefined') ? '' : state.index.parent.rows[parentIndex]['codshift' + _.padStart(day, 2, '0')]
        state.index.child.rows[index]['typwork' + _.padStart(day, 2, '0')] = (typeof state.index.parent.rows[parentIndex] === 'undefined') ? '' : state.index.parent.rows[parentIndex]['typwork' + _.padStart(day, 2, '0')]
      }
    },
    [types.SET_HRMS18E_INLINE_DATA_CHILD] (state, inlineDataChild) {
      state.inlineDataChild = inlineDataChild
    },
    [types.SET_HRMS18E_CURRENT_DAY_CHILD] (state, currentDayChild) {
      state.currentDayChild = currentDayChild
    },
    [types.SET_HRMS18E_TRADITIONAL_DAYS] (state, traditionalDays) {
      state.traditionalDays = traditionalDays
    },
    [types.SET_HRMS18E_SHUTDOWN_DAYS] (state, shutdownDays) {
      state.shutdownDays = shutdownDays
    }
  },
  actions: {
    [types.TOGGLE_HRMS18E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRMS18E_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS18E_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRMS18E_COLUMNS_LABELS] ({ commit }) {
      hrms18e.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS18E_LABELS, { labels: data.labels, month: '', year: '' })
          commit(types.SET_HRMS18E_UPDATE_COLUMNS_PARENT)
          commit(types.SET_HRMS18E_UPDATE_COLUMNS_CHILD)
          commit(types.SET_HRMS18E_COLUMNS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS18E_TRADITIONAL_AND_SHUTDOWN_DAYS] ({ commit }, searchParams) {
      hrms18e.getTraditionalAndShutdownDays(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS18E_TRADITIONAL_DAYS, data.traditional)
          commit(types.SET_HRMS18E_SHUTDOWN_DAYS, data.shutdown)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS18E_INDEX] ({ state, commit, dispatch }, searchParams) {
      hrms18e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS18E_SEARCH_INDEX, searchParams)
          commit(types.SET_HRMS18E_SUM_DAY_IN_MONTH)
          commit(types.SET_HRMS18E_LABELS, { labels: state.labels, month: searchParams.month, year: searchParams.year })
          commit(types.SET_HRMS18E_UPDATE_COLUMNS_PARENT)
          commit(types.SET_HRMS18E_UPDATE_COLUMNS_CHILD)
          commit(types.SET_HRMS18E_COLUMNS, state.labels)
          commit(types.SET_HRMS18E_INDEX_PARENT, data.table1)
          commit(types.SET_HRMS18E_INDEX_CHILD, data.table2)
          commit(types.SET_HRMS18E_INDEX_CHILD_BY_PARENT, data.table1.rows[0])
          dispatch(types.RECEIVED_HRMS18E_TRADITIONAL_AND_SHUTDOWN_DAYS, searchParams)
          commit(types.SET_HRMS18E_CURRENT_DAY_PARENT, '')
          commit(types.SET_HRMS18E_CURRENT_TYPEWORK_PARENT, '')
          commit(types.SET_HRMS18E_TARGET_TYPEWORK_PARENT, '')
          commit(types.SET_HRMS18E_CURRENT_CODSHIFT_PARENT, '')
          commit(types.SET_HRMS18E_TARGET_CODSHIFT_PARENT, '')
          commit(types.SET_HRMS18E_TARGET_CODCALEN_PARENT, '')
          commit(types.SET_HRMS18E_CURRENT_TYPEWORK_CHILD, '')
          commit(types.SET_HRMS18E_CURRENT_CODSHIFT_CHILD, '')
          commit(types.SET_HRMS18E_TARGET_TYPEWORK_CHILD, '')
          commit(types.SET_HRMS18E_TARGET_CODSHIFT_CHILD, '')
          commit(types.SET_HRMS18E_TARGET_CODEMPID_CHILD, '')
        })
        .catch((response) => {
          const data = response.response.data
          let objectData = {
            parent: {
              total: 0,
              rows: []
            },
            child: {
              total: 0,
              rows: []
            },
            childByParent: {
              total: 0,
              rows: []
            }
          }
          commit(types.SET_HRMS18E_INDEX_PARENT, objectData.parent)
          commit(types.SET_HRMS18E_INDEX_CHILD, objectData.child)
          commit(types.SET_HRMS18E_INDEX_CHILD_BY_PARENT, objectData.childByParent)
          swal({
            title: '', text: data.response, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS18E_INDEX_SAVE] ({ commit, dispatch }, { searchIndex, sendParams }) {
      hrms18e.postIndex({ searchIndex: searchIndex, sendParams: sendParams })
        .then((response) => {
          const data = JSON.parse(response.request.response)
          dispatch(types.RECEIVED_HRMS18E_INDEX, searchIndex)
          swal({
            title: '', text: data.response, html: true, type: 'success'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS18E_TYPEWORK_CODSHIFT_ON_PERIOD_CHILD] ({ state, commit }, { dtestrt, dteend, codshift, period, day }) {
      let weekName = [ 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT' ]
      let dayStrt = dtestrt.substring(0, 2)
      let dayEnd = dteend.substring(0, 2)
      let childIndex = state.index.child.rows.map(function (childRow) {
        return childRow.codempid
      }).indexOf(state.targetCodempidChild)
      let childKeys = Object.keys(state.index.child.rows[childIndex]).filter(function (childKey) {
        return childKey.indexOf('codshift') > -1
      })
      let month = state.searchIndex.month
      let year = state.searchIndex.year
      var mydate = year + '-' + _.padStart(month, 2, '0') + '-' + '01T00:00:00'
      var fullDayName = moment(mydate).format('dddd')
      let dayIndex = weekName.map(function (weekDay) {
        return weekDay
      }).indexOf(fullDayName.substring(0, 3).toUpperCase())
      for (let childKey of childKeys) {
        if (parseInt(childKey.substring(8)) >= parseInt(dayStrt) && parseInt(childKey.substring(8)) <= parseInt(dayEnd)) {
          if (period) {
            let typework = 'W'
            if (day.indexOf(weekName[dayIndex]) > -1) {
              typework = 'H'
            }
            let targetTypework = 'typwork' + childKey.substring(8)
            commit(types.SET_HRMS18E_TYPEWORK_TO_TARGET_TYPEWORK_CHILD, { typework: typework, targetTypework: targetTypework })
          }
          if (codshift !== '') {
            let targetCodshift = childKey
            commit(types.SET_HRMS18E_CODSHIFT_TO_TARGET_CODSHIFT_CHILD, { codshift: codshift, targetCodshift: targetCodshift })
          }
        }
        dayIndex = (dayIndex + 1 > 6) ? 0 : ++dayIndex
      }
    },
    [types.POST_HRMS18E_TYPEWORK_CODSHIFT_ON_PERIOD_PARENT] ({ state, commit }, { dtestrt, dteend, codshift, period, day }) {
      let weekName = [ 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT' ]
      let dayStrt = dtestrt.substring(0, 2)
      let dayEnd = dteend.substring(0, 2)
      let parentIndex = state.index.parent.rows.map(function (parentRow) {
        return parentRow.codcalen
      }).indexOf(state.targetCodcalenParent)
      let parentKeys = Object.keys(state.index.parent.rows[parentIndex]).filter(function (parentKey) {
        return parentKey.indexOf('codshift') > -1
      })
      let month = state.searchIndex.month
      let year = state.searchIndex.year
      var mydate = year + '-' + _.padStart(month, 2, '0') + '-' + '01T00:00:00'
      var fullDayName = moment(mydate).format('dddd')
      let dayIndex = weekName.map(function (weekDay) {
        return weekDay
      }).indexOf(fullDayName.substring(0, 3).toUpperCase())
      for (let parentKey of parentKeys) {
        if (parseInt(parentKey.substring(8)) >= parseInt(dayStrt) && parseInt(parentKey.substring(8)) <= parseInt(dayEnd)) {
          if (period) {
            let typework = 'W'
            if (day.indexOf(weekName[dayIndex]) > -1) {
              typework = 'H'
            }
            let targetTypework = 'typwork' + parentKey.substring(8)
            commit(types.SET_HRMS18E_TYPEWORK_TO_TARGET_TYPEWORK_PARENT, { typework: typework, targetTypework: targetTypework })
          }
          if (codshift !== '') {
            let targetCodshift = parentKey
            commit(types.SET_HRMS18E_CODSHIFT_TO_TARGET_CODSHIFT_PARENT, { codshift: codshift, targetCodshift: targetCodshift })
          }
        }
        dayIndex = (dayIndex + 1 > 6) ? 0 : ++dayIndex
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms18e/index.js